import { render } from "./log.vue?vue&type=template&id=2167a1f2&scoped=true"
import script from "./log.vue?vue&type=script&lang=js"
export * from "./log.vue?vue&type=script&lang=js"

import "./log.vue?vue&type=style&index=0&id=2167a1f2&lang=less"
import "./log.vue?vue&type=style&index=1&id=2167a1f2&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2167a1f2"]])

export default __exports__